<script setup>
import {
  ref,
  onMounted,
  computed,
  watch,
} from 'vue';
import { DateRangePickerComponent } from '@frontend/web/src/js/components/DateRangePickerComponent.js';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
});
const emit = defineEmits('update:modelValue', 'apply', 'cancel');

const datePicker = ref();

const dateRange = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
});

onMounted(() => {
  datePicker.value = new DateRangePickerComponent($('.js-datepicker-filter'), { minDate: new Date() });
  datePicker.value.on('apply', (ev, picker) => {
    const formatStart = picker.startDate.format('DD-MM-YYYY');
    const formatEnd = picker.endDate.format('DD-MM-YYYY');
    dateRange.value = [formatStart, formatEnd];
    ev.currentTarget.value = `${formatStart} - ${formatEnd}`;
  });
  datePicker.value.on('cancel', (ev, picker) => {
    dateRange.value = [];
    datePicker.value.reset();
  });
  datePicker.value.reset();
});

watch(dateRange, (newValue) => {
  if (!newValue[1]) datePicker.value.reset();
});
</script>

<template>
  <div class="i-date-picker js-filter-date">
    <input
      id="filter-date"
      type="text"
      inputmode="numeric"
      class="i-date-picker__input js-datepicker-filter"
      placeholder=""
      autocomplete="off"
      readonly
    >
    <svg width="20" height="20" class="icon icon_down i-date-picker__icon">
      <use xlink:href="#down" />
    </svg>
  </div>
</template>

<style lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";

.i-date-picker {
  position: relative;
  border-radius: $border-radius;
  border: 1px solid $primary;
  background-color: $primary;
  display: inline-flex;
  max-width: 264px;
  min-width: 264px;

  &.opened {
    z-index: 120001;

    .i-date-picker {
      &__icon {
        transform: translateY(-50%) rotate(-180deg);
      }
    }
  }

  &__input {
    width: 100%;
    height: 40px;
    padding: 11px 16px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: transparent;
    font-size: 14px;
    cursor: pointer;
    transition: border-color 0.3s;
    color: $white;

    &:hover {
      border-color: transparent;
    }
  }

  &__icon {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    transition: transform 0.3s;
  }

  @media (max-width: $screen-md) {
    max-width: none;
  }

  @media (max-width: $screen-xs) {
    border-radius: 0;

    &__input {
      font-size: 16px;
      font-weight: 700;
      height: 48px;
    }
  }
}
</style>
